module.exports = __webpack_public_path__ + "img/22_26.5c3f48c4.png";